export const getRandom = (min: number, max: number) =>
  Math.random() * (max - min) + min;
